<template>
  <div class="home-container">
    <div class="header-container">
      <div class="flex-center">
        <img class="header-logo-img" src="~@/assets/images/logo.png" @click="$router.push({ path: '/' })" />
        <span style="font-size: 14px; font-weight: bold; color: black">大头问卷系统</span>
      </div>
      <div class="right-header">
        <el-dropdown class="avatar-container" trigger="click" size="medium">
          <div class="avatar-wrapper" style="cursor: pointer">
            <i class="el-icon-user" style="margin: 0 5px"></i>
            <span class="user_name">{{ getUserInfo.name }}</span>
            <i class="el-icon-caret-bottom" style="top: 20px"></i>
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <el-dropdown-item>
              <span>{{ getUserInfo.name }}</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logoutHandle">
              <p class="person-menu-item">
                <font-icon class="fas fa-sign-out" />
                退出登录
              </p>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="content-container">
      <!-- 导航菜单 -->
      <menu-tree :navTree="getNavTree"></menu-tree>
      <div class="view-container">
        <router-view />
      </div>
      <div v-if="showHello && $route.path === '/home'" class="hello-container flex-center" @click="handleClick">
        <el-image
          class="hello-container-img"
          :style="{ height: defaultH + 'px' }"
          src="https://cdn.jmj1995.com/survey/hello.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { createFormRequest } from '@/api/project/form'
import MenuTree from '@/components/MenuTree'
import { pick } from 'lodash'
export default {
  name: 'NewIndex',
  components: { MenuTree },
  data() {
    return {
      defaultActiveMenu: '/project/my',
      defaultMenuList: [
        {
          id: 99,
          path: '/workOrder',
          name: '行动工单',
          icon: 'el-icon-menu',
          children: [
            {
              id: 100,
              path: '/workOrder/rule',
              name: '行动规则',
              icon: null
            },
            {
              id: 101,
              path: '/workOrder/list',
              name: '工单列表',
              icon: null
            }
          ]
        }
      ],
      showHello: false,
      defaultH: window.innerHeight < 980 ? 745 * 0.7 : 745
    }
  },
  computed: {
    getStore() {
      return store
    },
    getUserInfo() {
      try {
        return JSON.parse(this.getStore.getters['user/userInfo'])
      } catch (e) {
        return {}
      }
    },
    getNavTree() {
      try {
        let narData = JSON.parse(this.getStore.getters['user/navTree'])
        const filterNavData = _filterRoutes(narData)
        console.log({ filterNavData })
        return filterNavData
      } catch (e) {
        return []
      }
    }
  },
  created() {
    let user = this.getStore.getters['user/userInfo'] || {}
    const isAdmin = user.admin
    if (!user) {
      this.$router.push({
        path: '/login',
        query: {
          redirect: router.currentRoute.fullPath
        }
      })
    } else if (this.$route.path == '/') {
      this.showHello = true
      // 将主路由 / 重定向到首页
      this.$router.push({ path: '/home' })
    }
    if (this.$route.path == '/home') {
      this.showHello = true
    }
  },
  methods: {
    createBlankTemplate() {
      createFormRequest({
        description: '快来填写你的问卷描述吧',
        type: 'ORDINARY',
        name: '问卷名称'
      }).then((res) => {
        this.$router.push({
          path: '/project/form',
          query: { key: res.data.formKey }
        })
      })
    },
    logoutHandle() {
      this.$confirm('您确定要退出登录吗？', '退出确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('user/logout').then(() => {
            router.push({
              path: '/login'
            })
          })
        })
        .catch(() => {})
    },
    handleClick() {
      if (this.getNavTree.length > 0) return
      this.$message.warning('您没有访问数据的权限，请联系管理员')
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.defaultH = window.innerHeight < 980 ? 745 * 0.7 : 745
    })
  },
  destroyed() {
    window.removeEventListener('resize', () => {})
  }
}
/**
 *
 * 路由数据格式转
 */
function _filterRoutes(routes) {
  // 过滤设置hideMenu的路由
  let res =
    routes
      .filter((route) => !route.meta.hideMenu)
      .map((route) => {
        //只保留需要的数据
        let bkroute = pick(route, ['id', 'icon', 'name', 'path', 'mate'])
        if (route.children) {
          bkroute.children = _filterRoutes(route.children)
        }
        return bkroute
      }) || []
  return res
}
</script>

<style lang="scss" scoped>
$menuActiveText: #409eff;

.home-container {
  background-color: rgba(247, 247, 247, 90);
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
}

.content-container {
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: row;
  .view-container {
    flex-direction: column;
    overflow: hidden auto;
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }
}

.header-container {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #dcdfe6;
  min-width: 1024px;

  .header-logo-img {
    width: 90px;
    height: 18px;
    float: left;
    margin-top: 5px;
    margin-left: 30px;
    margin-right: 10px;
  }

  .right-header {
    display: flex;
    flex-direction: row;

    > * {
      margin: 0 20px;
    }
  }

  .user-avatar {
    width: 35px;
    height: 35px;
    border-radius: 100px;
    cursor: pointer;
    vertical-align: middle;
  }
}

.menu-box {
  min-width: 12%;
  display: flex;
  padding: 5px;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 100);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .menu-view {
    flex: 1;
    padding: 20px;
    text-align: center;

    .menu-item-active {
      color: #ffffff !important;
      background-color: $menuActiveText;
    }

    .menu-item {
      color: #333;
      font-size: 16px;
      line-height: 20px;
      padding: 5px 15px;
      margin-top: 15px;
      border-radius: 5px;
      text-align: center;

      &:hover {
        cursor: pointer;
        color: $menuActiveText;
      }

      & .fas:hover {
        color: $menuActiveText;
      }

      .fas {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin: 5px;
      }

      span {
        margin-left: 10px;
      }
    }
  }
}

.user-person-menu {
  .nick-name {
    color: rgba(70, 70, 70, 86);
    font-size: 14px;
    text-align: left;
  }

  .person-menu-item {
    color: rgba(70, 70, 70, 86);
    font-size: 14px;
    text-align: left;

    &:hover {
      cursor: pointer;
      color: $menuActiveText;
    }
  }

  .el-divider {
    margin: 5px 0;
  }

  .person-menu-divider {
    background-color: rgba(210, 210, 210, 78);
    border: 1px solid rgba(210, 210, 210, 78);
  }
}

.about-container {
  text-align: center;

  .fa-user {
    font-size: 19px;
    color: rgba(172, 172, 172, 100);
    margin: 1px;
  }
}
.user-info-form {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.user_name {
  display: inline-block;
  margin: 0 5px;
}
.hello-container {
  width: 100%;
  height: 100%;
  &-img {
    transition-property: height;
    transition-duration: 0.3s;
  }
}
</style>
